import { render, staticRenderFns } from "./time-select2.vue?vue&type=template&id=36c49ba2&scoped=true&"
import script from "./time-select2.vue?vue&type=script&lang=ts&"
export * from "./time-select2.vue?vue&type=script&lang=ts&"
import style0 from "./time-select2.vue?vue&type=style&index=0&id=36c49ba2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c49ba2",
  null
  
)

export default component.exports